/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';

import { AircraftPaxcountResponse } from '../models/aircraft-paxcount-response';
import { FeedbacksCountResponse } from '../models/feedbacks-count-response';
import { FlightReportStatisticsResponse } from '../models/flight-report-statistics-response';
import { FlightTypePaxcountResponse } from '../models/flight-type-paxcount-response';

/**
 * dashboard api
 */
@Injectable({ providedIn: 'root' })
export class DashboardService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `genaralStatistics()` */
  static readonly GenaralStatisticsPath =
    '/api/v1/dashboard/flight-report-statistics';

  /**
   * fetch general count details.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `genaralStatistics()` instead.
   *
   * This method doesn't expect any request body.
   */
  genaralStatistics$Response(
    params?: {
      /**
       * The trip date start from
       */
      from?: string;

      /**
       * The trip date end to
       */
      to?: string;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<FlightReportStatisticsResponse>> {
    const rb = new RequestBuilder(
      this.rootUrl,
      DashboardService.GenaralStatisticsPath,
      'get'
    );
    if (params) {
      rb.query('from', params.from, {});
      rb.query('to', params.to, {});
    }

    return this.http
      .request(
        rb.build({ responseType: 'json', accept: 'application/json', context })
      )
      .pipe(
        filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
        map((r: HttpResponse<any>) => {
          return r as StrictHttpResponse<FlightReportStatisticsResponse>;
        })
      );
  }

  /**
   * fetch general count details.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `genaralStatistics$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  genaralStatistics(
    params?: {
      /**
       * The trip date start from
       */
      from?: string;

      /**
       * The trip date end to
       */
      to?: string;
    },
    context?: HttpContext
  ): Observable<FlightReportStatisticsResponse> {
    return this.genaralStatistics$Response(params, context).pipe(
      map(
        (
          r: StrictHttpResponse<FlightReportStatisticsResponse>
        ): FlightReportStatisticsResponse => r.body
      )
    );
  }

  /** Path part for operation `getFlightTypePaxcount()` */
  static readonly GetFlightTypePaxcountPath =
    '/api/v1/dashboard/flight-type-pax-count';

  /**
   * fetch flight type passenger count.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getFlightTypePaxcount()` instead.
   *
   * This method doesn't expect any request body.
   */
  getFlightTypePaxcount$Response(
    params?: {
      /**
       * The trip date start from
       */
      from?: string;

      /**
       * The trip date end to
       */
      to?: string;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<FlightTypePaxcountResponse>> {
    const rb = new RequestBuilder(
      this.rootUrl,
      DashboardService.GetFlightTypePaxcountPath,
      'get'
    );
    if (params) {
      rb.query('from', params.from, {});
      rb.query('to', params.to, {});
    }

    return this.http
      .request(
        rb.build({ responseType: 'json', accept: 'application/json', context })
      )
      .pipe(
        filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
        map((r: HttpResponse<any>) => {
          return r as StrictHttpResponse<FlightTypePaxcountResponse>;
        })
      );
  }

  /**
   * fetch flight type passenger count.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getFlightTypePaxcount$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getFlightTypePaxcount(
    params?: {
      /**
       * The trip date start from
       */
      from?: string;

      /**
       * The trip date end to
       */
      to?: string;
    },
    context?: HttpContext
  ): Observable<FlightTypePaxcountResponse> {
    return this.getFlightTypePaxcount$Response(params, context).pipe(
      map(
        (
          r: StrictHttpResponse<FlightTypePaxcountResponse>
        ): FlightTypePaxcountResponse => r.body
      )
    );
  }

  /** Path part for operation `getFeedbacksCountByFeedbackType()` */
  static readonly GetFeedbacksCountByFeedbackTypePath =
    '/api/v1/dashboard/feedbacks-count';

  /**
   * fetch feedbacks count by feedback type.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getFeedbacksCountByFeedbackType()` instead.
   *
   * This method doesn't expect any request body.
   */
  getFeedbacksCountByFeedbackType$Response(
    params?: {
      /**
       * The trip date start from
       */
      from?: string;

      /**
       * The trip date end to
       */
      to?: string;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<FeedbacksCountResponse>> {
    const rb = new RequestBuilder(
      this.rootUrl,
      DashboardService.GetFeedbacksCountByFeedbackTypePath,
      'get'
    );
    if (params) {
      rb.query('from', params.from, {});
      rb.query('to', params.to, {});
    }

    return this.http
      .request(
        rb.build({ responseType: 'json', accept: 'application/json', context })
      )
      .pipe(
        filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
        map((r: HttpResponse<any>) => {
          return r as StrictHttpResponse<FeedbacksCountResponse>;
        })
      );
  }

  /**
   * fetch feedbacks count by feedback type.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getFeedbacksCountByFeedbackType$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getFeedbacksCountByFeedbackType(
    params?: {
      /**
       * The trip date start from
       */
      from?: string;

      /**
       * The trip date end to
       */
      to?: string;
    },
    context?: HttpContext
  ): Observable<FeedbacksCountResponse> {
    return this.getFeedbacksCountByFeedbackType$Response(params, context).pipe(
      map(
        (
          r: StrictHttpResponse<FeedbacksCountResponse>
        ): FeedbacksCountResponse => r.body
      )
    );
  }

  /** Path part for operation `getAircraftPaxcount()` */
  static readonly GetAircraftPaxcountPath =
    '/api/v1/dashboard/aircraft-pax-count';

  /**
   * fetch aircraft passenger count.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getAircraftPaxcount()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAircraftPaxcount$Response(
    params?: {
      /**
       * The trip date start from
       */
      from?: string;

      /**
       * The trip date end to
       */
      to?: string;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<AircraftPaxcountResponse>> {
    const rb = new RequestBuilder(
      this.rootUrl,
      DashboardService.GetAircraftPaxcountPath,
      'get'
    );
    if (params) {
      rb.query('from', params.from, {});
      rb.query('to', params.to, {});
    }

    return this.http
      .request(
        rb.build({ responseType: 'json', accept: 'application/json', context })
      )
      .pipe(
        filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
        map((r: HttpResponse<any>) => {
          return r as StrictHttpResponse<AircraftPaxcountResponse>;
        })
      );
  }

  /**
   * fetch aircraft passenger count.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getAircraftPaxcount$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAircraftPaxcount(
    params?: {
      /**
       * The trip date start from
       */
      from?: string;

      /**
       * The trip date end to
       */
      to?: string;
    },
    context?: HttpContext
  ): Observable<AircraftPaxcountResponse> {
    return this.getAircraftPaxcount$Response(params, context).pipe(
      map(
        (
          r: StrictHttpResponse<AircraftPaxcountResponse>
        ): AircraftPaxcountResponse => r.body
      )
    );
  }
}
